(function() {
  'use strict';

  var CATEGORIES = [
    { name: 'Dudak Bakımı',    keywords: ['lip', 'dudak balmı', 'dudak bakım'] },
    { name: 'Vücut Bakımı',    keywords: ['vücut'] },
    { name: 'Temizleyiciler',   keywords: ['temizleme', 'temizleyici', 'cleansing'] },
    { name: 'Güneş Kremleri',  keywords: ['centella soothing', 'sun serum', 'güneş', 'spf 50', 'korumalı', 'leke karşıtı, cilt tonu eşitleyici'] },
    { name: 'Serumlar',         keywords: ['serum', 'yaşlanma karşıtı', 'kırışıklık', 'göz çevresi', 'niacinamide', 'arbutin', 'c vitamini'] },
    { name: 'Tonik',            keywords: ['tonik', 'aha', 'bha', 'glikolik', 'gözenek sıkılaştırıcı'] },
    { name: 'Nemlendirici',     keywords: ['cilt bakım kremi'] }
  ];

  var POLL_INTERVAL = 500;
  var MAX_ATTEMPTS = 40;
  var attempts = 0;
  var initialized = false;

  function categorizeCard(text) {
    var lower = text.toLowerCase().replace(/\s+/g, ' ');
    for (var c = 0; c < CATEGORIES.length; c++) {
      var cat = CATEGORIES[c];
      for (var k = 0; k < cat.keywords.length; k++) {
        if (lower.indexOf(cat.keywords[k].toLowerCase()) !== -1) {
          return cat.name;
        }
      }
    }
    return 'Diğer';
  }

  function decodeLabel(raw) {
    if (!raw) return '';
    var text = raw.replace(/\\u[\dA-Fa-f]{4}/g, function(m) {
      return String.fromCharCode(parseInt(m.replace('\\u', ''), 16));
    });
    text = text.replace(/\\n/g, ' ').replace(/<br\s*\/?>/gi, ' ').replace(/\s+/g, ' ').trim();
    var tmp = document.createElement('textarea');
    tmp.innerHTML = text;
    return tmp.value;
  }

  function restoreFullText(cards) {
    var fiberKey = Object.keys(cards[0]).find(function(k) {
      return k.indexOf('__reactFiber') === 0;
    });
    if (!fiberKey) return;

    cards.forEach(function(card) {
      try {
        var fiber = card[fiberKey];
        var parent = fiber.return;
        if (!parent || !parent.memoizedProps || !parent.memoizedProps.redeemRuleItem) return;
        var item = parent.memoizedProps.redeemRuleItem;

        /* Title (name alanından) */
        var title = card.querySelector('[class*="RedeemListItemTitle"]');
        if (title && title.textContent.indexOf('\u2026') !== -1 && item.name) {
          title.textContent = decodeLabel(item.name);
        }

        /* Description (customerFacingLabel alanından) */
        var desc = card.querySelector('[class*="RedeemListItemDescription"]');
        if (desc && desc.textContent.indexOf('\u2026') !== -1 && item.customerFacingLabel) {
          desc.textContent = decodeLabel(item.customerFacingLabel);
        }
      } catch (e) { /* silent fail per card */ }
    });
  }

  function init() {
    if (initialized) return;
    if (document.querySelector('.wiwify-tab-nav')) return;

    var list = document.querySelector('.appstleLoyaltyPageV2WaysToRedeemList');
    var header = document.querySelector('.appstleLoyaltyPageV2WaysToRedeemHeader');

    if (!list || !header) {
      attempts++;
      if (attempts < MAX_ATTEMPTS) setTimeout(init, POLL_INTERVAL);
      return;
    }

    initialized = true;

    var cards = Array.prototype.slice.call(list.children);
    if (cards.length === 0) return;

    /* Kesilen metinleri React fiber'dan tam haliyle geri yükle */
    restoreFullText(cards);

    var categoryCounts = { 'Tümü': cards.length };

    cards.forEach(function(card) {
      var text = card.textContent || '';
      var cat = categorizeCard(text);
      card.setAttribute('data-wiwify-cat', cat);
      if (!categoryCounts[cat]) categoryCounts[cat] = 0;
      categoryCounts[cat]++;
    });

    var activeCategories = ['Tümü'];
    CATEGORIES.forEach(function(cat) {
      if (categoryCounts[cat.name] && categoryCounts[cat.name] > 0) {
        activeCategories.push(cat.name);
      }
    });
    if (categoryCounts['Diğer'] && categoryCounts['Diğer'] > 0) {
      activeCategories.push('Diğer');
    }

    if (activeCategories.length <= 2) return;

    var nav = document.createElement('div');
    nav.className = 'wiwify-tab-nav';

    activeCategories.forEach(function(catName, idx) {
      var btn = document.createElement('button');
      btn.className = 'wiwify-tab-btn' + (idx === 0 ? ' active' : '');
      btn.setAttribute('data-cat', catName);
      btn.setAttribute('type', 'button');
      btn.innerHTML = catName + ' <span class="tab-count">' + categoryCounts[catName] + '</span>';

      btn.addEventListener('click', function() {
        var allBtns = nav.querySelectorAll('.wiwify-tab-btn');
        for (var b = 0; b < allBtns.length; b++) {
          allBtns[b].classList.remove('active');
        }
        btn.classList.add('active');

        var selectedCat = btn.getAttribute('data-cat');
        var delay = 0;
        cards.forEach(function(card) {
          var cardCat = card.getAttribute('data-wiwify-cat');
          if (selectedCat === 'Tümü' || cardCat === selectedCat) {
            card.classList.remove('wiwify-hidden');
            card.classList.add('wiwify-visible');
            card.style.animationDelay = delay + 'ms';
            delay += 40;
          } else {
            card.classList.remove('wiwify-visible');
            card.classList.add('wiwify-hidden');
            card.style.animationDelay = '0ms';
          }
        });
      });

      nav.appendChild(btn);
    });

    header.parentNode.insertBefore(nav, header.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 1000); });
  } else {
    setTimeout(init, 1000);
  }

  var observer = new MutationObserver(function() {
    if (!initialized) return;
    var existing = document.querySelector('.wiwify-tab-nav');
    var list = document.querySelector('.appstleLoyaltyPageV2WaysToRedeemList');
    if (!existing && list) {
      initialized = false;
      attempts = 0;
      init();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();